var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTutorial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 77,
    viewBox: "0 0 88 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7641 60.6173C46.2294 62.7917 41.7708 62.7917 38.2324 60.6173L14.6667 46.1157V66C14.6667 72.0757 19.5911 77 25.6667 77H62.3334C68.4091 77 73.3334 72.0757 73.3334 66V46.1157L49.7641 60.6173Z",
    fill: "url(#paint0_linear_343_24645)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.236 9.04933L7.47632 27.9767C2.36499 31.1227 2.36499 38.5477 7.47632 41.6937L38.2323 60.621C41.767 62.7953 46.2257 62.7953 49.764 60.621L80.52 41.6937C85.6313 38.5477 85.6313 31.1227 80.52 27.9767L49.764 9.04933C46.2293 6.87133 41.7707 6.87133 38.236 9.04933Z",
    fill: "#F4F5FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3257 30.9121L68.1781 20.3794C66.5684 14.8134 61.2041 16.0894 61.2041 16.0894L45.6562 25.8075C45.124 25.7154 44.5696 25.6667 44.0001 25.6667C39.95 25.6667 36.6667 28.1291 36.6667 31.1667C36.6667 34.2043 39.95 36.6667 44.0001 36.6667C48.0502 36.6667 51.3334 34.2043 51.3334 31.1667C51.3334 31.0814 51.3308 30.9965 51.3257 30.9121Z",
    fill: "url(#paint1_linear_343_24645)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_24645",
    x1: 44.0001,
    y1: 46.1157,
    x2: 44.0001,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_24645",
    x1: 52.4224,
    y1: 15.9633,
    x2: 52.4224,
    y2: 36.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.a2852bf47dcc9835477494f5625fbb38.svg";
export { ForwardRef as ReactComponent };